
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"1238","height":"377","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1238 284L722 0 0 255l358 122z","fill":"#C2E1BB","fill-rule":"evenodd"}})])
      }
    
      }
    